import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { breakpoint, theme } from '../../../theme';
import { ActionButtonsSection } from './ActionButtonsSection';

export const ActionsSection = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: flex-end;

  > * + * {
    margin-top: ${theme.spacings[3].rem};
  }

  > *:first-child {
    margin-right: ${theme.spacings[1].rem};

    ${breakpoint('sm')`
      margin-right: ${theme.spacings[3].rem};
    `}
  }
`;

const ActionContextSection = styled.div`
  display: flex;
  flex-direction: column;
  min-width: fit-content;
  flex: 1 1 auto;

  ${breakpoint('sm')`
    flex: 0 1 30%;
  `};

  > * + * {
    margin-top: ${theme.spacings[1].rem};

    ${breakpoint('sm')`
      margin-top: ${theme.spacings[2].rem};
    `}
  }
`;

export type ActionRowProps = {
  actionButtonContent?: React.ReactNode;
};

export const ActionRow: React.FC<PropsWithChildren<ActionRowProps>> = ({
  actionButtonContent,
  children,
}) => {
  return (
    <ActionsSection>
      <ActionContextSection>{children}</ActionContextSection>
      <ActionButtonsSection>{actionButtonContent}</ActionButtonsSection>
    </ActionsSection>
  );
};
